export default __webpack_public_path__ + "static/media/main1.269b6df4.jpg";